const baseStyle = {
  paddingY: 8,
  paddingX: 16,
  maxWidth: 240,
  borderRadius: 'radii.2',
  elevation: 'shadows.3'
}

const appearances = {
  card: {
    backgroundColor: 'white'
  },
  default: {
    color: 'white',
    backgroundColor: 'colors.gray800'
  }
}

const sizes = {}

export default {
  baseStyle,
  appearances,
  sizes
}
